import { formatFecha, getTipoLeccionLabel } from "../historialLeccionesUtils";
import VisualizarIcon from "../../../../assets/icons/viewIcon.svg";

const HistorialLeccionesRow = ({ leccion, onVerHistorial }) => {
  return (
    <tr
      className="p-2 text-left bg-white cursor-pointer hover:bg-gray-50"
      onClick={() => onVerHistorial(leccion)}
    >
      {/* Identificador de la lección (en la uma es el campo titulo) */}
      <td className="border-2 border-r-0 rounded-l-md font-sans text-left pl-4 pr-2">
        {leccion?.uma?.titulo}
      </td>

      {/* Nombre de la lección (en la uma es el campo descripcion) */}
      <td className="border-y-2 font-sans text-left px-2">
        {leccion?.uma?.descripcion}
      </td>

      {/* Tipo de contenido */}
      <td className="border-y-2 font-sans text-center">
        {getTipoLeccionLabel(leccion?.uma?.umaTipo)}
      </td>

      {/* Última modificación */}
      <td className="border-y-2 font-sans text-center">
        {formatFecha(leccion?.ultimaEdicion)}
      </td>

      {/* Total de movimientos */}
      <td className="border-y-2 font-sans text-center">
        {leccion?.totalCambios}
      </td>

      {/* Acciones */}
      <td className="border-2 rounded-r-md border-l-0">
        <div className="flex items-center justify-around">
          <button
            title="Ver historial de cambios"
            className="w-5 flex"
            onClick={(event) => {
              event.stopPropagation();
              onVerHistorial(leccion);
            }}
          >
            <img src={VisualizarIcon} className="w-5 h-5" alt="Ver historial" />
          </button>
        </div>
      </td>
    </tr>
  );
};

export default HistorialLeccionesRow;
